import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/store/index';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { verifyStatus, verifyFieldNames } from '@/pages/timeline/sections/timeline/timelineSections/verify/constants'
import { keyForCodeForSection, sectionLockStatus } from '@/pages/timeline/sections/timeline/timelineSections/constants'
import { listOfUiForCertificates, certificateStatus } from "@/pages/timeline/sections/timeline/timelineSections/certificate/constants";
import { setTimelineAccordionStatusSlice } from '@/store/slices/timeline/timelineAccordionStatusSlice';
import { setCertificateUISlice } from '@/store/slices/timeline/certificateUISlice';
import { allSeriesCompleted, checkAnyInstallmentUnPaidHelper } from '@/utils/index'

import { examStatusEnu, examResults } from '@/pages/dashboard/constants'
import SectionAccordance from '@/components/timeline/SectionAccordance'


import BlueUnFilledHeart from "@/assets/icons/blueUnFilledHeart.png";
import BlueUnFilledMan from "@/assets/icons/blueUnFilledMan.png";
import BlueUnFilledWatch from "@/assets/icons/blueUnFilledWatch.png";
import BlueUnFilledExam from "@/assets/icons/blueUnFilledExam.png";
import BlueUnfilledFile from "@/assets/icons/blueUnfilledFile.png";
import BlueUnFilledCertificate from "@/assets/icons/blueUnFilledCertificate.png";


import RedUnFilledHeart from "@/assets/icons/redUnFilledHeart.png";
import RedUnFilledMan from "@/assets/icons/redUnFilledMan.png";
import RedUnFilledWatch from "@/assets/icons/redUnFilledWatch.png";
import RedUnFilledExam from "@/assets/icons/redUnFilledExam.png";
import RedActionReq from "@/assets/icons/redActionReq.png";

import RedWarning from "@/assets/icons/redWarning.png";
import RedLock from "@/assets/icons/redLock.png";
import RedUnfilledFile from "@/assets/icons/redUnfilledFile.png";
import RedUnFilledCertificate from "@/assets/icons/redUnFilledCertificate.png";


import greenUnFilledHeart from "@/assets/icons/greenUnFilledHeart.png";
import GreenUnFilledMan from "@/assets/icons/greenUnFilledMan.png";
import GreenUnFilledWatch from "@/assets/icons/greenUnFilledWatch.png";
import GreenUnFilledExam from "@/assets/icons/greenUnFilledExam.png";
import GreenUnfilledFile from "@/assets/icons/greenUnfilledFile.png";
import GreenUnFilledCertificate from "@/assets/icons/greenUnFilledCertificate.png";

import GreyTick from "@/assets/icons/greyTick.png";
import GreyUnFilledExam from "@/assets/icons/greyUnFilledExam.png";
import GreyLock from "@/assets/icons/greyLock.png";
import GreyUnfilledFile from "@/assets/icons/greyUnfilledFile.png";
import GreyUnFilledCertificate from "@/assets/icons/greyUnFilledCertificate.png";



import LightGretTick from "@/assets/icons/lightGretTick.png";
import PinkWarning from "@/assets/icons/pinkWarning.png";
import PinkLock from "@/assets/icons/pinkLock.png";
import WhiteLock from "@/assets/icons/whiteLock.png";
import LightRedActionReq from "@/assets/icons/lightRedActionReq.png";


import { useState, useEffect } from 'react';
import moment from 'moment';
import { nocStatus } from './timelineSections/noc/constants';
import { themes } from '@/constants/colors_v2';

export default function TimelineSection() {
    const dispatch = useDispatch();
    const { timeline, common } = useLocalTranslation();

    const defaultValuesOfAccordionDetails = [
        {
            section: timeline.enrolled,
            keyForCode: keyForCodeForSection.enrolled,
            icon: BlueUnFilledHeart,
            colorCode: "blue"
        },
        {
            section: timeline.verify,
            keyForCode: keyForCodeForSection.verify,
            icon: BlueUnFilledMan,
            colorCode: "blue"
        },
        {
            section: timeline.watch,
            keyForCode: keyForCodeForSection.watch,
            icon: BlueUnFilledWatch,
            colorCode: "blue"
        },
        {
            section: timeline.exam,
            keyForCode: keyForCodeForSection.exam,
            icon: BlueUnFilledExam,
            colorCode: "blue"
        }
    ]

    let defaultValuesForCompletedAccordionDetails = [
        {
            section: timeline.enrolled,
            keyForCode: keyForCodeForSection.enrolled,
            icon: greenUnFilledHeart,
            colorCode: "green"
        },
        {
            section: timeline.verify,
            keyForCode: keyForCodeForSection.verify,
            icon: GreenUnFilledMan,
            colorCode: "green"
        },
        {
            section: timeline.watch,
            keyForCode: keyForCodeForSection.watch,
            icon: GreenUnFilledWatch,
            colorCode: "green"
        },
        {
            section: timeline.exam,
            keyForCode: keyForCodeForSection.exam,
            icon: GreenUnFilledExam,
            colorCode: "green"
        }
    ]


    const [accordionDetails, setAccordionDetails] = useState(defaultValuesOfAccordionDetails)
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    useEffect(() => {
        accordionDetailsHandler()
    }, [timelineDetails]);


    const hideCertificate = () => {
        // isEligibleForCertificate = false
        // hideTimelineCertificate = true
        //     hide Certificate 


        // isEligibleForCertificate = true
        // hideTimelineCertificate = true
        //     show Certificate 


        // isEligibleForCertificate = false
        // hideTimelineCertificate = false
        //     show Certificate 


        // isEligibleForCertificate = true
        // hideTimelineCertificate = false
        //     show Certificate 

        if (timelineDetails.hideTimelineCertificate && !timelineDetails.isEligibleForCertificate) {
            return true
        }

        return false
    }


    const accordionDetailsHandler = () => {
        if (timelineDetails.isNocRequired) {
            addNewObjToAccordionDetails(timeline.submitSectionHeading, keyForCodeForSection.submit, BlueUnfilledFile, 'blue')
        }
        if (!hideCertificate()) {
            addNewObjToAccordionDetails(timeline.certificate, keyForCodeForSection.certificate, BlueUnFilledCertificate, 'blue')
        }
        updateAccordionDetails()
    }

    const addNewObjToAccordionDetails = (sectionHeading: string, keyCodeToAdd: string, iconToAdd: string, colorCodeToAdd: string) => {
        //@ts-ignore
        setAccordionDetails(prevDetails => {
            const alreadyExists = prevDetails.some(item => item.keyForCode === keyCodeToAdd);

            if (alreadyExists) return prevDetails;

            const newEnrolledItem = {
                section: sectionHeading,
                keyForCode: keyCodeToAdd,
                icon: iconToAdd,
                colorCode: colorCodeToAdd
            };

            return [...prevDetails, newEnrolledItem];
        });
    }

    const updateAccordionDetails = () => {
        const defaultTagValues = {
            actionIconWidth: "12px",
            tickIconWidth: "15px",
            textSize: "14px"
        }

        let tempTimelineAccordionStatusSlice: Record<string, string> = {
            [keyForCodeForSection.verify]: sectionLockStatus.unLocked,
            [keyForCodeForSection.exam]: sectionLockStatus.unLocked,
            [keyForCodeForSection.watch]: sectionLockStatus.unLocked,
            [keyForCodeForSection.submit]: sectionLockStatus.unLocked,
            [keyForCodeForSection.certificate]: sectionLockStatus.unLocked,
        }


        let isInstallmentOverdue_ = isInstallmentOverdue()
        let checkAnyInstallmentUnPaid_ = checkAnyInstallmentUnPaidHelper(timelineDetails.installmentSchedule)
        // ----------------- START : logic of enrolled ----------------
        let enrolledTag = {
            text: "",
            icon: "",
            colorCode: "",
            iconWidth: "",
            textSize: ""
        }
        let enrolledLeftBarColorCode = ""
        let enrolledLeftBarIcon = ""
        if (timelineDetails.purchaseDate) {
            enrolledTag = {
                text: common.statusText.enrolledOn + " " + moment(timelineDetails.purchaseDate).format('DD MMM, YYYY'),
                icon: GreyTick,
                colorCode: "grey",
                iconWidth: defaultTagValues.tickIconWidth,
                textSize: defaultTagValues.textSize
            }
        }

        if (timelineDetails.installmentSchedule && timelineDetails.installmentSchedule.length > 0) {
            if (isInstallmentOverdue_) {
                enrolledLeftBarColorCode = "red"
                enrolledLeftBarIcon = RedUnFilledHeart
                enrolledTag = {
                    text: common.status.actionRequired,
                    icon: RedActionReq,
                    colorCode: "red",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
            }
        }
        // ----------------- END : logic of enrolled ----------------


        // ----------------- START : logic of verify ----------------
        // installmentOverdue -> Red Lock
        // profileVerifyStatus: not_submitted / action_req / inelajbel -> Action required
        // verifiedAt: -> verifec on
        // verificationSubmittedAt: -> submited on

        let verifyTag = {
            text: "",
            icon: "",
            colorCode: "",
            iconWidth: "",
            textSize: ""
        }
        let verifyLeftBarColorCode = ""
        let verifyLeftBarIcon = ""
        let verifyHasSectionLock = false

        const verify_action_required = timelineDetails[verifyFieldNames.profileVerifyStatus] === verifyStatus.action_required

        const verify_not_submitted = timelineDetails[verifyFieldNames.profileVerifyStatus] === verifyStatus.not_submitted

        const verify_rejected = timelineDetails[verifyFieldNames.profileVerifyStatus] === verifyStatus.rejected

        if (isInstallmentOverdue_) {
            verifyLeftBarIcon = RedUnFilledMan
            verifyLeftBarColorCode = "red"
            verifyTag = {
                text: common.status.locked,
                icon: RedLock,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
            verifyHasSectionLock = true
        }
        else if (verify_action_required || verify_not_submitted || verify_rejected) {
            verifyLeftBarIcon = RedUnFilledMan
            verifyLeftBarColorCode = "red"
            verifyTag = {
                text: common.status.actionRequired,
                icon: verify_not_submitted ? RedWarning : RedActionReq,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
        } else if (!timelineDetails.isEligibleForCertificate) {
            verifyLeftBarIcon = RedUnFilledMan
            verifyLeftBarColorCode = "red"
            verifyTag = {
                text: common.status.ineligible,
                icon: RedWarning,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
        } else if (timelineDetails.verifiedAt) {
            verifyLeftBarIcon = BlueUnFilledMan
            verifyLeftBarColorCode = "blue"
            verifyTag = {
                text: common.statusText.verifiedOn + " " + moment(timelineDetails.verifiedAt).format('DD MMM, YYYY'),
                icon: GreyTick,
                colorCode: "grey",
                iconWidth: defaultTagValues.tickIconWidth,
                textSize: defaultTagValues.textSize
            }
        } else if (timelineDetails.verificationSubmittedAt) {
            verifyLeftBarIcon = BlueUnFilledMan
            verifyLeftBarColorCode = "blue"
            verifyTag = {
                text: common.statusText.submittedOn + " " + moment(timelineDetails.verificationSubmittedAt).format('DD MMM, YYYY'),
                icon: GreyTick,
                colorCode: "grey",
                iconWidth: defaultTagValues.tickIconWidth,
                textSize: defaultTagValues.textSize
            }
        }
        // ----------------- END : logic of verify ----------------



        // ----------------- START : logic of watch ----------------
        let watchTag = {
            text: "",
            icon: "",
            colorCode: "",
            iconWidth: "",
            textSize: ""
        }
        let watchLeftBarColorCode = ""
        let watchLeftBarIcon = ""
        let watchHasSectionLock = false


        const seriesCompletedOn = allSeriesCompleted(timelineDetails.series)
        // const seriesCompletedOn = "2025-08-04T09:33:21.310+00:00" // testing
        // debugger
        if (verify_not_submitted
            || timelineDetails.basicDetailsStatus === verifyStatus.action_required
            || verify_rejected) {
            watchLeftBarIcon = RedUnFilledWatch
            watchLeftBarColorCode = "red"
            watchTag = {
                text: common.status.locked,
                icon: RedLock,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
            watchHasSectionLock = true
        }
        else if (isInstallmentOverdue_) {
            watchLeftBarIcon = RedUnFilledWatch
            watchLeftBarColorCode = "red"
            watchTag = {
                text: common.status.locked,
                icon: RedLock,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
            watchHasSectionLock = true
        } else if (seriesCompletedOn != null) {
            watchLeftBarIcon = BlueUnFilledWatch
            watchLeftBarColorCode = "blue"
            watchTag = {
                text: common.statusText.completedOn + " " + moment(seriesCompletedOn).format('DD MMM, YYYY'),
                icon: GreyTick,
                colorCode: "grey",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
        }
        // else if ()

        // ----------------- END : logic of watch ----------------



        // ----------------- START : logic of exam ----------------
        let examTag = {
            text: "",
            icon: "",
            colorCode: "",
            iconWidth: "",
            textSize: ""
        }
        let examLeftBarColorCode = ""
        let examLeftBarIcon = ""
        let examHasSectionLock = false
        let calculatedExamStatus = getExamStatus()
        if (!timelineDetails.isEligibleForExam) {
            examLeftBarIcon = RedUnFilledExam
            examLeftBarColorCode = "red"
            examTag = {
                text: common.status.ineligible,
                icon: RedWarning,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
        }
        else if (isInstallmentOverdue_ || verify_rejected) {
            examLeftBarIcon = RedUnFilledExam
            examLeftBarColorCode = "red"
            examTag = {
                text: common.status.locked,
                icon: RedLock,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
            examHasSectionLock = true
        } else if (timelineDetails.courseStartAt === null) {
            examLeftBarIcon = GreyUnFilledExam
            examLeftBarColorCode = "grey"
            examTag = {
                text: common.status.locked,
                icon: GreyLock,
                colorCode: "grey",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
            examHasSectionLock = true
        }
        else if (calculatedExamStatus === "greyLocked") {
            examLeftBarIcon = GreyUnFilledExam
            examLeftBarColorCode = "grey"
            examTag = {
                text: common.status.locked,
                icon: GreyLock,
                colorCode: "grey",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
            examHasSectionLock = true
        }
        else if (calculatedExamStatus === "action_required") {
            examLeftBarIcon = RedUnFilledExam
            examLeftBarColorCode = "red"
            examTag = {
                text: common.status.actionRequired,
                icon: RedWarning,
                colorCode: "red",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
        } else if (calculatedExamStatus === "completed") {
            examLeftBarIcon = BlueUnFilledExam
            examLeftBarColorCode = "blue"
            examTag = {
                text: common.statusText.completedOn + " " + moment(timelineDetails.examSubmittedAt).format('DD MMM, YYYY'),
                icon: GreyTick,
                colorCode: "grey",
                iconWidth: defaultTagValues.actionIconWidth,
                textSize: defaultTagValues.textSize
            }
        }
        // ----------------- END : logic of exam ----------------




        // ----------------- START : logic of submit ----------------
        let nocTag = {
            text: "",
            icon: "",
            colorCode: "",
            iconWidth: "",
            textSize: ""
        }
        let nocLeftBarColorCode = ""
        let nocLeftBarIcon = ""
        let nocHasSectionLock = false
        // debugger
        if (timelineDetails.isNocRequired) {
            if (isInstallmentOverdue_) {
                nocLeftBarIcon = RedUnfilledFile
                nocLeftBarColorCode = "red"
                nocTag = {
                    text: common.status.locked,
                    icon: RedLock,
                    colorCode: "red",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                nocHasSectionLock = true
            }
            else if (verify_not_submitted || verify_action_required || verify_rejected) {
                nocLeftBarIcon = RedUnfilledFile
                nocLeftBarColorCode = "red"
                nocTag = {
                    text: common.status.locked,
                    icon: RedLock,
                    colorCode: "red",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                nocHasSectionLock = true
            } else if (timelineDetails.examStatus === examStatusEnu.locked) {
                nocLeftBarIcon = GreyUnfilledFile
                nocLeftBarColorCode = "grey"
                nocTag = {
                    text: common.status.locked,
                    icon: GreyLock,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                nocHasSectionLock = true
            } else if (timelineDetails.nocStatus === nocStatus.submitted && timelineDetails.nocSubmittedAt) {
                nocLeftBarIcon = BlueUnfilledFile
                nocLeftBarColorCode = "blue"
                nocTag = {
                    text: common.statusText.completedOn + " " + moment(timelineDetails.nocSubmittedAt).format('DD MMM, YYYY'),
                    icon: GreyTick,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                nocHasSectionLock = true
            } else if (timelineDetails.nocStatus === nocStatus.verified && timelineDetails.nocVerifiedAt) {
                nocLeftBarIcon = BlueUnfilledFile
                nocLeftBarColorCode = "blue"
                nocTag = {
                    text: common.statusText.verifiedOn + " " + moment(timelineDetails.nocVerifiedAt).format('DD MMM, YYYY'),
                    icon: GreyTick,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                nocHasSectionLock = true
            }
        }
        // ----------------- END : logic of submit ----------------




        // ----------------- START : logic of certificate ----------------
        let certificateTag = {
            text: "",
            icon: "",
            colorCode: "",
            iconWidth: "",
            textSize: ""
        }
        let certificateLeftBarColorCode = ""
        let certificateLeftBarIcon = ""
        let certificateHasSectionLock = false

        if (!hideCertificate()) {
            if (!timelineDetails.isEligibleForCertificate) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.inEligible))
                certificateLeftBarIcon = RedUnFilledCertificate
                certificateLeftBarColorCode = "red"
                certificateTag = {
                    text: common.status.locked,
                    icon: RedLock,
                    colorCode: "red",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            }
            else if (isInstallmentOverdue_) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.overDue))
                certificateLeftBarIcon = RedUnFilledCertificate
                certificateLeftBarColorCode = "red"
                certificateTag = {
                    text: common.status.locked,
                    icon: RedLock,
                    colorCode: "red",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            }
            else if (checkAnyInstallmentUnPaid_) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.overDue))
                certificateLeftBarIcon = GreyUnFilledCertificate
                certificateLeftBarColorCode = "grey"
                certificateTag = {
                    text: common.status.locked,
                    icon: GreyLock,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            }
            else if (verify_rejected) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.verificationPending))
                certificateLeftBarIcon = RedUnFilledCertificate
                certificateLeftBarColorCode = "red"
                certificateTag = {
                    text: common.status.locked,
                    icon: RedLock,
                    colorCode: "red",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            }
            else if (timelineDetails.idVerificationStatus !== verifyStatus.verified) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.verificationPending))
                certificateLeftBarIcon = GreyUnFilledCertificate
                certificateLeftBarColorCode = "grey"
                certificateTag = {
                    text: common.status.locked,
                    icon: GreyLock,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            } else if (timelineDetails.certificateStatus === null) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.examPending))
                certificateLeftBarIcon = GreyUnFilledCertificate
                certificateLeftBarColorCode = "grey"
                certificateTag = {
                    text: common.status.locked,
                    icon: GreyLock,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            } else if (isExtendDurationReq()) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.extendDuration))
                certificateLeftBarIcon = GreyUnFilledCertificate
                certificateLeftBarColorCode = "grey"
                certificateTag = {
                    text: common.status.locked,
                    icon: GreyLock,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            } else if (timelineDetails.isNocRequired === true && timelineDetails.nocStatus !== nocStatus.verified) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.nocVerificationPending))
                certificateLeftBarIcon = GreyUnFilledCertificate
                certificateLeftBarColorCode = "grey"
                certificateTag = {
                    text: common.status.locked,
                    icon: GreyLock,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
                certificateHasSectionLock = true
            } else if (timelineDetails.certificateStatus === certificateStatus.ready) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.ready))
            } else if (timelineDetails.certificateStatus === certificateStatus.claimed) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.claimed))
                certificateTag = {
                    text: common.statusText.claimedOn + " " + moment(timelineDetails.certificateClaimedAt).format('DD MMM, YYYY'),
                    icon: GreyTick,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
            } else if (timelineDetails.certificateDeliveryConfirmedAt) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.deliveryConfrimedAt))
                certificateTag = {
                    text: common.statusText.delivered,
                    icon: GreyTick,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
            } else if (timelineDetails.certificateStatus === certificateStatus.dispatch) {
                dispatch(setCertificateUISlice(listOfUiForCertificates.dispatch))
                certificateTag = {
                    text: common.statusText.dispatchedOn + " " + moment(timelineDetails.certificateDispatchedAt).format('DD MMM, YYYY'),
                    icon: GreyTick,
                    colorCode: "grey",
                    iconWidth: defaultTagValues.actionIconWidth,
                    textSize: defaultTagValues.textSize
                }
            }
        }
        // ----------------- END : logic of certificate ----------------



        // ----------------- START : logic to update leftBar ----------------
        let timelineAllStepsCompleted = false
        // debugger
        if (!isInstallmentOverdue_ && !checkAnyInstallmentUnPaid_ && calculatedExamStatus === "completed") {
            let anyIssue = false
            if (timelineDetails.isNocRequired === true && timelineDetails.nocStatus !== nocStatus.verified) {
                anyIssue = true
            }
            if (!hideCertificate() && timelineDetails.certificateDeliveryConfirmedAt === null) {
                anyIssue = true
            }
            if (!anyIssue) {
                //@ts-ignore
                const nocAlreadyExists = defaultValuesForCompletedAccordionDetails.some(item => item.keyForCode === keyForCodeForSection.submit);

                if (!nocAlreadyExists && timelineDetails.isNocRequired === true) {
                    defaultValuesForCompletedAccordionDetails.push({
                        //@ts-ignore
                        section: timeline.submitSectionHeading,
                        //@ts-ignore
                        keyForCode: keyForCodeForSection.submit,
                        icon: GreenUnfilledFile,
                        colorCode: "green"
                    })
                }

                //@ts-ignore
                const certificateAlreadyExists = defaultValuesForCompletedAccordionDetails.some(item => item.keyForCode === keyForCodeForSection.certificate);
                if (!certificateAlreadyExists && !hideCertificate()) {
                    defaultValuesForCompletedAccordionDetails.push({
                        //@ts-ignore
                        section: timeline.certificate,
                        //@ts-ignore
                        keyForCode: keyForCodeForSection.certificate,
                        icon: GreenUnFilledCertificate,
                        colorCode: "green"
                    })
                }
                setAccordionDetails(defaultValuesForCompletedAccordionDetails)
                timelineAllStepsCompleted = true
            }
        }


        // console.log(enrolledLeftBarColorCode)
        if (!timelineAllStepsCompleted) {
            if (enrolledLeftBarColorCode != "") {
                setAccordionDetails(prevDetails =>
                    prevDetails.map(item =>
                        item.keyForCode === keyForCodeForSection.enrolled
                            ? {
                                ...item,
                                icon: enrolledLeftBarIcon,
                                colorCode: enrolledLeftBarColorCode,
                            }
                            : item
                    )
                );
            }

            if (verifyLeftBarColorCode != "") {
                setAccordionDetails(prevDetails =>
                    prevDetails.map(item =>
                        item.keyForCode === keyForCodeForSection.verify
                            ? {
                                ...item,
                                icon: verifyLeftBarIcon,
                                colorCode: verifyLeftBarColorCode
                            }
                            : item
                    )
                );
            }

            if (watchLeftBarColorCode != "") {
                setAccordionDetails(prevDetails =>
                    prevDetails.map(item =>
                        item.keyForCode === keyForCodeForSection.watch
                            ? {
                                ...item,
                                icon: watchLeftBarIcon,
                                colorCode: watchLeftBarColorCode
                            }
                            : item
                    )
                );
            }

            if (examLeftBarColorCode != "") {
                setAccordionDetails(prevDetails =>
                    prevDetails.map(item =>
                        item.keyForCode === keyForCodeForSection.exam
                            ? {
                                ...item,
                                icon: examLeftBarIcon,
                                colorCode: examLeftBarColorCode
                            }
                            : item
                    )
                );
            }

            if (nocLeftBarColorCode != "") {
                setAccordionDetails(prevDetails =>
                    prevDetails.map(item =>
                        //@ts-ignore
                        item.keyForCode === keyForCodeForSection.submit
                            ? {
                                //@ts-ignore
                                ...item,
                                icon: nocLeftBarIcon,
                                colorCode: nocLeftBarColorCode
                            }
                            : item
                    )
                );
            }

            if (certificateLeftBarColorCode != "") {
                setAccordionDetails(prevDetails =>
                    prevDetails.map(item =>
                        //@ts-ignore
                        item.keyForCode === keyForCodeForSection.certificate
                            ? {
                                //@ts-ignore
                                ...item,
                                icon: certificateLeftBarIcon,
                                colorCode: certificateLeftBarColorCode
                            }
                            : item
                    )
                );
            }
        }
        // ----------------- END : logic to update leftBar ----------------



        // ----------------- START : logic to update tag ----------------        
        if (enrolledTag.text != "") {
            // Handle logic for dark theme 
            if(currentTheme === themes.dark){
                if(enrolledTag.icon === GreyTick){
                    enrolledTag.icon = LightGretTick
                } 
                else if(enrolledTag.icon === RedActionReq){
                    enrolledTag.icon = LightRedActionReq
                }
            }

            setAccordionDetails(prevDetails =>
                prevDetails.map(item =>
                    item.keyForCode === keyForCodeForSection.enrolled
                        ? {
                            ...item,
                            tag: enrolledTag
                        }
                        : item
                )
            );
        }

        if (verifyTag.text != "") {
            // Handle logic for dark theme 
            if (currentTheme === themes.dark) {
                if (verifyTag.icon === RedWarning) {
                    verifyTag.icon = PinkWarning
                } 
                else if(verifyTag.icon === GreyTick){
                    verifyTag.icon = LightGretTick
                }
                else if(verifyTag.icon === RedActionReq){
                    verifyTag.icon = LightRedActionReq
                }

            }

            setAccordionDetails(prevDetails =>
                prevDetails.map(item =>
                    item.keyForCode === keyForCodeForSection.verify
                        ? {
                            ...item,
                            tag: verifyTag
                        }
                        : item
                )
            );
        }


        if (watchTag.text != "") {
            // Handle logic for dark theme 
            if (currentTheme === themes.dark) {
                if (watchTag.icon === RedLock) {
                    watchTag.icon = PinkLock
                }
                else if(watchTag.icon === GreyTick){
                    watchTag.icon = LightGretTick
                }
            }

            setAccordionDetails(prevDetails =>
                prevDetails.map(item =>
                    item.keyForCode === keyForCodeForSection.watch
                        ? {
                            ...item,
                            tag: watchTag
                        }
                        : item
                )
            );
        }


        if (examTag.text != "") {
            // Handle logic for dark theme 
            if (currentTheme === themes.dark) {
                if (examTag.icon === RedLock) {
                    examTag.icon = PinkLock
                } 
                else if (examTag.icon === RedWarning) {
                    examTag.icon = PinkWarning
                } 
                else if (examTag.icon === GreyLock) {
                    examTag.icon = WhiteLock
                }
                else if(examTag.icon === GreyTick){
                    examTag.icon = LightGretTick
                }
            }
            
            
            setAccordionDetails(prevDetails =>
                prevDetails.map(item =>
                    item.keyForCode === keyForCodeForSection.exam
                        ? {
                            ...item,
                            tag: examTag
                        }
                        : item
                )
            );
        }


        if (nocTag.text != "") {
            // Handle logic for dark theme 
            if (currentTheme === themes.dark) {
                if (nocTag.icon === RedLock) {
                    nocTag.icon = PinkLock
                } 
                else if (nocTag.icon === GreyLock) {
                    nocTag.icon = WhiteLock
                }
                else if(nocTag.icon === GreyTick){
                    nocTag.icon = LightGretTick
                }
            }

            setAccordionDetails(prevDetails =>
                prevDetails.map(item =>
                    //@ts-ignore
                    item.keyForCode === keyForCodeForSection.submit
                        ? {
                            //@ts-ignore
                            ...item,
                            tag: nocTag
                        }
                        : item
                )
            );
        }


        if (certificateTag.text != "") {
            // Handle logic for dark theme 
            if (currentTheme === themes.dark) {
                if (certificateTag.icon === RedLock) {
                    certificateTag.icon = PinkLock
                } 
                else if (certificateTag.icon === GreyLock) {
                    certificateTag.icon = WhiteLock
                }
                else if(certificateTag.icon === GreyTick){
                    certificateTag.icon = LightGretTick
                }
            }

            setAccordionDetails(prevDetails =>
                prevDetails.map(item =>
                    //@ts-ignore
                    item.keyForCode === keyForCodeForSection.certificate
                        ? {
                            //@ts-ignore
                            ...item,
                            tag: certificateTag
                        }
                        : item
                )
            );
        }
        // ----------------- END : logic to update tag ----------------



        // ----------------- START : logic to update timeline accordion status ----------------
        let updateTimelineAccordionStatusSlice = false
        if (verifyHasSectionLock) {
            tempTimelineAccordionStatusSlice[keyForCodeForSection.verify] = sectionLockStatus.locked
            updateTimelineAccordionStatusSlice = true
        }

        if (watchHasSectionLock) {
            tempTimelineAccordionStatusSlice[keyForCodeForSection.watch] = sectionLockStatus.locked
            updateTimelineAccordionStatusSlice = true
        }

        if (examHasSectionLock) {
            tempTimelineAccordionStatusSlice[keyForCodeForSection.exam] = sectionLockStatus.locked
            updateTimelineAccordionStatusSlice = true
        }

        if (nocHasSectionLock) {
            tempTimelineAccordionStatusSlice[keyForCodeForSection.submit] = sectionLockStatus.locked
            updateTimelineAccordionStatusSlice = true
        }

        if (certificateHasSectionLock) {
            tempTimelineAccordionStatusSlice[keyForCodeForSection.certificate] = sectionLockStatus.locked
            updateTimelineAccordionStatusSlice = true
        }


        if (updateTimelineAccordionStatusSlice) {
            dispatch(setTimelineAccordionStatusSlice(tempTimelineAccordionStatusSlice));
        }
        // ----------------- END : logic to update timeline accordion status ----------------
    }



    // ----------------- START : util fns ----------------
    const isExtendDurationReq = () => {
        let extendDurationReq = false
        // console.log(timelineDetails)
        if (timelineDetails.extendedDurationPresetId
            && timelineDetails.extendedDurationPresetDetails
            && Object.entries(timelineDetails.extendedDurationPresetDetails).length > 0) {
            if (timelineDetails.minimumSeriesValidityInDays
                && timelineDetails.series
                && timelineDetails.series.length > 0) {
                // debugger
                let totalValidityDays = timelineDetails.series.reduce((sum: any, item: any) => sum + (item.validityDays || 0), 0);
                if (totalValidityDays
                    && totalValidityDays < timelineDetails.minimumSeriesValidityInDays) {
                    extendDurationReq = true
                }
            }
        }
        return extendDurationReq;
    }
    // ----------------- END : util fns ----------------

    const isInstallmentOverdue = () => {
        return timelineDetails.installmentOverdue
    }

    const getExamStatus = () => {
        let status = ''
        if (timelineDetails.examStatus === examStatusEnu.locked) {
            status = "greyLocked"
        }
        if (timelineDetails.examStatus === examStatusEnu.submitted
            || timelineDetails.examStatus === examStatusEnu.viewResult
            || timelineDetails.examStatus === examStatusEnu.hideResult) {
            if (timelineDetails?.resultDetails?.result === examResults.failed) {
                status = "action_required"
            }
            else if (timelineDetails.examSubmittedAt != null) {
                status = "completed"
            }
        }
        return status
    }
    return (
        <SectionAccordance
            accordionDetails={accordionDetails}
        />
    );
}
